import React, { useEffect } from "react";
import "./products.css";

import Avation1 from "../Assets/avation1.png";

import { useStateContext } from "../contexts/ContextProvider";

import Exam1 from "../Assets/exm1.jpg";
import Exam2 from "../Assets/exm2.jpg";
import Exam3 from "../Assets/exm3.jpg";
import Exam4 from "../Assets/exm4.jpg";
import Exam5 from "../Assets/exm5.jpg";
import ProductsBanner from "./ProductsBanner";

const Examiner = () => {
  const { handleShowContact } = useStateContext();

  const title = "The Examiner";
  const body =
    "An examination and evaluation platform The Fidus Examiner is a one stop solution for managing assessments/exams both offline and online.";

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <ProductsBanner product="examiner" title={title} body={body} />
      {/* <div className="product-section">
        <div className="product-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading">
                <h2>The Examiner</h2>
                <div className="back-circle"></div>
              </div>
            </div>
          </div>
          <div className="product-bg">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-content">
                  <p>
                    An examination and evaluation platform The Fidus Examiner is
                    a one stop solution for managing assessments/exams both
                    offline and online.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="product-section">
        <div className="product-container">
          <div className="product-text">
            <div className="row">
              <div className="col-xl-4 col-lg-6">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Insightful Learner and Examiner Dashboards</h3>
                      <p>
                        Well, isn’t that the whole point? To get insights, the
                        examiner portal gives you the ideal data dashboard that
                        visualizes data to provide you with in depth learner
                        analytics that will help you evaluate the gaps in skills
                        and competencies of your work force. This tool will take
                        your training needs analysis to another level!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-lg-6">
                <div className="figure">
                  <img src={Exam1} alt="" />
                </div>
              </div>
            </div>
            <div className="h-200 one"></div>
            <div className="row alternate">
              <div className="col-xl-8 col-lg-7">
                <div className="figure">
                  <img src={Exam2} alt="" />
                </div>
              </div>
              <div className="col-xl-4 col-lg-5">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Remote Proctoring Services</h3>
                      <p>
                        An examination is only as effective as its execution,
                        and we have the perfect solution! The remote proctoring
                        feature offers capabilities such as learner
                        authentication, comprehensive proctoring technology, and
                        a secure exam browser that disables other tabs on the
                        learner’s screen.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 two"></div>
            <div className="row alternate2">
              <div className="col-lg-6"></div>
              <div className="col-lg-6">
                <div className="figure">
                  <img src={Exam3} alt="" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Intuitive User Experience</h3>
                      <p>
                        Our team of experienced UI/UX designers have carefully
                        crafted our online and offline examination platforms for
                        user-friendliness. Whether accessing exams remotely or
                        offline, our interface ensures easy navigation. With our
                        examination module, no prior knowledge of SaaS-based
                        products is required; it's as simple as clicking on a
                        link.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200"></div>
            <div className="row alternate3">
              <div className="col-lg-6">
                <div className="figure">
                  <img src={Exam4} alt="" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Easy Exam Scheduler</h3>
                      <p>
                        The exam scheduler has been designed to bring all your
                        scheduled exams on a single dashboard, giving you easy
                        and simple access,
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200"></div>
            <div className="row alternate2">
              <div className="col-lg-6"></div>

              <div className="col-lg-6">
                <div className="figure">
                  <img src={Exam5} alt="" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>
                        Elevate Exam Creation with the Fidus Examiner Portal
                      </h3>
                      <p>
                        Crafting effective exams has never been easier. Choose
                        from a variety of question formats, including
                        multiple-choice, Drag and Drop, and descriptive
                        questions. With convenient features like bulk uploader,
                        creating and managing your question repository is a
                        breeze.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Examiner;
